export const chinese = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: '流行搭配',
      top: '顶部',
      hello: '你好',
      in_your_cart: '在您的购物车中',
      search_result: '搜索结果如下',
      no_items_found: '找到 0 件商品',
      search_empty: '没有结果',
      call_staff: '我们已经收到了你的电话',
      sub_total: '小计',
      total: '共计',
      order_details: '订购详情',
      order_history: '订单历史',
      popup_pay: '你准备好付款了吗？',
      payment_success: '我们已经收到你的请求，完成付款',
      order_empty: '您的订单是空的',
      pending: '待制',
      served: '服务过的',
      confirmed: '服务过的',
      finish_cooking: '烹饪完成',
      cancelled: '取消了',
      ready_to_order: '准备订购吗？',
      order_success: '我们已收到您的订单请求。',
      maxQuantityPerOrder: '每个订单的最大菜数',
      topping_type_quantity: '最少 {{min}} - 最大 {{max}}',
      menu_excludes_vat: '单价没包括VAT。',
      rescanQR: '请重扫描为了下单。',
      choose_language_to_start: '请选择您的语言',
      extraFee: '加收费',
      discountAmount: '折扣',
      customizedService: '请问您需要什么',
      selectOption: '请选择一个选项',
      call_staff_reasons: '叫人员',
      choose_payment_method: '选择您的付款方式',
      payment_successfully: '付款成功',
      payment_failed: '付款失败',
      how_was_your_experience: '您的经历如何？',
      your_details: '入细节',
      how_many_people: '你们有多少人？',
      please_select_number_of_people: '*请选择包括婴儿在内的人数。',
      choose_number_of_people: 'Please select the number of people at your table today:',
      buffet: 'Buffet',
      order_placed: '已订单!',
      order_code: '订购代码',
      review_order: '请在这里给我们留下评价',
      popular: '受欢迎',
      hope_you_enjoyed: '希望您拥有美好时间',
      review_success: '非常感谢!',
      popup_food_error_order:
        '菜品 <span style="font-weight:{{fontWeight}}">{{nameFood}}</span> 缺货！',
      popup_topping_error_order:
        'The topping <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> out of stock!',
      input_a_name: '输入姓名',
      input_a_phone: '输入电话号码',
      why_we_need_it: '为什么我们需要它？',
      discount: '折扣',
      // tablet
      search: '搜索',
      call_staff_tablet: '呼叫服务员',
      bill: '账单',
      pay: '支付',
      table_number: '桌号：',
      ask_for_bill: '索取账单',
      ask_for_bill_decription: '点击“索取账单”，我们将为您带来账单。',
      not_yet: '尚未',
      quantity: '数量',
      item_table: '商品',
      status_table: '状态',
      price_table: '价格',
      other: '其他',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: '你已经到了终点',
      cart_empty: '您的购物车是空的',
      hint_cart_empty: '点击这里查看菜单',
      search_empty: '请检查你的拼写或尝试不同的关键词',
      call_staff: '我们将很快处理您的桌子，谢谢您的耐心。',
      popup_pay: "点选 '付款请求'，这样我们就可以把账单送到你的桌子上。",
      payment_success: '我们将很快处理您的桌子，谢谢您的耐心。',
      restaurant_on_capichi:
        '我们的餐厅也可以在<span style="color:{{colorText}}">Capichi</span>送货上门。',
      order_empty: '开始您的订单，添加您想吃的菜。',
      orderNotFound: '没查到订单',
      order_success: '我们将尽快为您的桌子提供服务, 谢谢您的耐心。',
      rescanQR: '因为我们已经结束您已下的订单，请您重扫描为了下这个餐厅的新订单。',
      order_food_and_drink: '订食物和饮料随时都可以',
      seek_for_help: '径直请求人员的帮助',
      ask_to_pay: '请求结账在您吃完后',
      or_ask_directly: '或者直接问',
      haveVAT: '未包括 {{vatRate}}% VAT',
      haveServiceFee: '服務費 {{serviceRate}}%',
      popup_payment_success:
        '您的在线支付已确认。 感谢您选择我们的服务，并希望您度过一段美好的时间和经历。',
      popup_payment_failed: '发生错误。请重试或使用其他付款方式。',
      tap_to_save_screen: '请将此屏幕打开给店内工作人员查看',
      checkouted_order: `感谢您今天选择在我们这用餐，我们真诚地希望您喜欢与我们一起度过的时光。
     如果您能在下面分享您的体验，以便我们能够发展和改进我们的餐厅，我们将不胜感激.`,
      review_success: '我们已收到您的评价，我们会从中采取下一次的改进。感谢您的帮助.',
      input_a_name:
        '您当前正在从具有不同订单的桌子上点餐，为了确保我们正确拆分订单，请输入一个简单的名称*来标识您的订单。',
      input_a_phone: '该电话号码用于在您成功下单时接收通知您订单状态的消息。',
      min_left: '{{min_left}}分鐘內您可以在菜單內吃到飽.',
    },
    // ================================= actions =================================
    actions: {
      call_staff: '寻求工作人员的帮助',
      pay: '缴付',
      back_to_top: '返回顶部',
      order: '秩序',
      go_back: '返回',
      see_menu: '查看菜单',
      order_now: '现在订购',
      clear_all: '清除所有',
      search_again: '再次搜索',
      retry: '重试',
      back_to_menu: '返回到菜单',
      ask_for_bill: '付款请求',
      not_yet: '还没有',
      discover: '发现',
      delete_dish: '删除',
      noteFood: '您的订单',
      addToCart: '加上購物車',
      addNote: '加笔记',
      confirmOrder: '确认',
      start_ordering: '开始下单',
      pay_online: '现在付款',
      send: '发',
      try_again: '重试',
      call_staff_for_help: '求助人员',
      skip: '跳过',
      next: '下一步',
      done: '完成',
      confirm: '确认',
      order_from_here: '在此点餐',
      tap_to_save_screen: '点击保存屏幕',
      see_a_menu: '查看菜单',
      update: '更新',
      cancel: '取消',
      add: '添加',
      ok: '好的',
      see_the_time: '查看时间',
    },
    // ================================= errors =================================
    errors: {
      server_error: '对不起，服务器无法接通',
      errorOutOfStock: '抱歉，这些菜没货了，请再点菜。',
      errorQuantityPerOrder: '您选的菜系已经超过最大数量。请重选。',
      errorQuantityExceeded: '抱歉，这道菜的数量不足以完成您的订单。 请重新选择菜数。',
      somethingWrong: '系统有错误，请重试',
      errorFoodHasChanged: '对不起，餐厅刚改了菜系详情，请重下单',
      warningMin: '请选择 {{min}}配料以上。',
      warningMax: '请选择 {{max}}配料以下。',
      notFoundFoodItem: '餐厅暂时不供应这道菜，请稍后再回来。',
      errorNotOpenTable: '您的桌子还没有可用，请叫服务员帮忙。',
      max_comment_review: '最多{{max}}文字',
      payment_method_changed: '付款方式已经更新。',
      payment_method_changed_desc: '请先刷新页面然后选择合适的付款方式。',
      max_characters: '最多 {{max}} 个字符',
      required_floor: '请进入您的楼层。',
      required_room: '请进入您的房号。',
      required_full_name: '请进入您的名字。',
      errorOutOfStockNEC: '这道菜已卖完',
      rating_already_existed: '很抱歉、此订单已被评价过',
      voucher_not_suitable: '此优惠券不适用。请再试一次',
      error: '错误',
      voucher_not_found: '优惠券代码不存在。 请使用别的代码。',
      voucher_outside_time_period: '优惠券代码无效或已过期。 请使用别的代码。',
      voucher_just_apply_for_restaurants: '此优惠券只能在这些{{restaurants}}可用',
      voucher_min_order_value: '优惠券代码适用于 {{min_order_value}} 起的订单',
      voucher_has_been_used: '优惠券代码已被使用',
      voucher_out_of_quantity: '此优惠券已过期。请使用别的优惠券',
      min_max_phone_number: '请输入 {{min}}-{{max}} 个字符之间的电话号码。',
    },
    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      zezoYen: '0 yen',
      required: '必需',
      optional: '任选',
      my_cart: '我的手推车',
      items_found: '找到的项目',
      sold_out: '已售完',
      items: '项目',
      powered_by: '由以下单位提供',
      vat: '增值税（VAT）',
      service_fee: '服务费',
      your_order: '您的订单',
      or: '或者',
      payment_methods: {
        international_card: '信用支付',
        atm: 'ATM轉帳',
        qr_code: '二维码转账',
        e_wallet: '电子钱包',
      },
      review_or_comment: '请给我们留下评论或评论',
      only_letters: '只接受字母',
      buffet: '自助餐',
      min_left: '还剩 <strong style="color:{{color}}">{{min_left}}</strong> 分钟',
      all_you_can_drink: '喝到饱',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: '搜索菜肴，菜单，饮料，...',
      choose_your_floor: '选择楼层',
      choose_your_room: '选择房号',
      your_full_name: '您的名字',
      no_results: '没结果',
      your_name: '你的名字',
      enter_voucher_code: '输入优惠代码',
      your_phone: '您的电话号码',
    },
    popup_start_buffet: {
      course_menu_has_started: '套餐菜单已上线。',
      time_limit: '时间限制',
      time_value: '{{value}}分钟',
      see_menu: '查看菜单',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description: '請將我們加為 LINE 好友以使用手機訂餐服務。',
      add_friend_btn: '加為 LINE 好友',
      already_added: '已添加為好友',
    },
  },
}
